// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__MXhru","label":"Category_label__2AtrR","content":"Category_content__1c95H","header":"Category_header__1OM_e","location":"Category_location__1AIK0"};